import { Typography } from 'antd'
import { White } from 'src/features/theme/KdsThemeColor'
import styled from 'styled-components'

const { Text } = Typography

export const TemplatePageContentWrapper = styled.div`
  padding: 20px 20px 20px 15px;
  min-height: 800px;
  background: ${White};
  overflow-x: auto;
`

/** 末尾に容量表示を持つページ内容。容量表示をカード下端へ寄せるため縦 flex にする。 */
export const TemplatePageContentWithCapacityWrapper = styled(
  TemplatePageContentWrapper,
)`
  display: flex;
  flex-direction: column;
`

export const ErrorMessageText = styled(Text)`
  color: red;
  font-weight: bold;
  margin-left: 20px;
  white-space: pre-line;
`
